.container {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 12px;
  color: var(--tuna-content-primary);
}

.body {
  font-size: var(--tuna-typography-fontSize-md);
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-wrap;
  color: var(--tuna-content-primary);
}

.caret {
  display: inline-block;
  width: 0.6ch;
  color: var(--tuna-content-secondary);
  animation: liveCaretPulse 0.8s ease-in-out infinite;
}

.stopRow {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-content-secondary);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.errorBox {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-feedback-error);
}

/* While streaming, collapse the markdown wrapper into the body's flow and
   inline the final block so the caret trails the last character. */
.markdownStreaming {
  display: contents;
}
.markdownStreaming > :last-child {
  display: inline;
}

@keyframes liveCaretPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

@media (prefers-reduced-motion: reduce) {
  .caret { animation: none; }
}
